import { Paper, Popper } from '@mui/material'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const StyledSearchBox = styled(Popper)`
  && {
    left: 50% !important;
    transform: translate(-50%, 80px) !important;
    z-index: 2 !important;

    @media (max-width: 800px) {
      transform: translate(-50%, 100px); !important;
    }
  }
`

export const StyledPaper = styled(Paper)`
  && {
    background: ${(props) => props.theme.colors.grayDark};
    width: 70vw;
    box-shadow:
      0px 8px 12px 6px rgba(0, 0, 0, 0.15),
      0px 4px 4px 0px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    padding: 24px;

    @media (max-width: 900px) {
      width: 90vw;
    }
  }
`

export const StyledScrollPaper = styled.div`
  max-height: 375px;
  overflow-y: auto;
  padding: 0 30px 0 0;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--color-graySemiDark);
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--color-gray);
    border-radius: 10px;
    border: 2px solid var(--color-graySemiDark);
  }

  scrollbar-width: thin;
  scrollbar-color: var(--color-gray) var(--color-graySemiDark);

  @media (max-width: 800px) {
    max-height: 70vh;
  }
`

export const StyledLink = styled(Link)`
  && {
    text-decoration: none;
    color: inherit;

    &:last-child {
      div {
        border-bottom: none;
        margin-bottom: 0;
      }
    }
  }
`

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 0;
  cursor: pointer;
  transition: 0.2s;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray};

  &:hover {
    background: ${(props) => props.theme.colors.graySemiDark};
  }
`

export const StyledItemEmpty = styled.div`
  padding: 12px 0;
`

export const StyledItemHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const StyledItemText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const StyledItemTitle = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.white};
`

export const StyledItemSubtitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.darkRed};
`

export const StyledItemQuotes = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  white-space: nowrap;

  b {
    margin-left: 4px;
  }
`

export const StyledItemDescription = styled.span`
  margin-top: 4px;
  padding: 4px 8px;
  width: calc(100% - 16px);
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  background: ${(props) => props.theme.colors.darkLight};
  font-size: 16px;
  color: ${(props) => props.theme.colors.white};
`
